/* eslint-disable quotes */
import {
  IABFilterType,
  FilterStateType,
  FilterGroupType,
  AppleFilterType,
  NamedEntityType,
} from '@insights_module/types/ContextualAndEntity';

export const FILTER_STATE = {
  ignore: 'ignore' as FilterStateType,
  includes: 'includes' as FilterStateType,
  excludes: 'excludes' as FilterStateType,
};

export const FILTERS_GROUP = {
  IAB: 'iab' as FilterGroupType,
  APPLE: 'apple' as FilterGroupType,
  NAMED_ENTITY: 'named_entity' as FilterGroupType,
};

export const CONTEXTUAL_FILTERS = {
  IAB: FILTERS_GROUP.IAB,
  APPLE: FILTERS_GROUP.APPLE,
};

export const IAB_FILTER_KEY = {
  attractions: 'iab_attractions' as IABFilterType,
  automotive: 'iab_automotive' as IABFilterType,
  books_and_literature: 'iab_books_and_literature' as IABFilterType,
  business_and_finance: 'iab_business_and_finance' as IABFilterType,
  careers: 'iab_careers' as IABFilterType,
  communication: 'iab_communication' as IABFilterType,
  crime: 'iab_crime' as IABFilterType,
  disasters: 'iab_disasters' as IABFilterType,
  education: 'iab_education' as IABFilterType,
  entertainment: 'iab_entertainment' as IABFilterType,
  events: 'iab_events' as IABFilterType,
  family_and_relationships: 'iab_family_and_relationships' as IABFilterType,
  fine_art: 'iab_fine_art' as IABFilterType,
  food_and_drink: 'iab_food_and_drink' as IABFilterType,
  genres: 'iab_genres' as IABFilterType,
  healthy_living: 'iab_healthy_living' as IABFilterType,
  hobbies_and_interests: 'iab_hobbies_and_interests' as IABFilterType,
  holidays: 'iab_holidays' as IABFilterType,
  home_and_garden: 'iab_home_and_garden' as IABFilterType,
  law: 'iab_law' as IABFilterType,
  maps_and_navigation: 'iab_maps_and_navigation' as IABFilterType,
  medical_health: 'iab_medical_health' as IABFilterType,
  music: 'iab_music' as IABFilterType,
  personal_celebrations_and_life_events:
    'iab_personal_celebrations_and_life_events' as IABFilterType,
  personal_finance: 'iab_personal_finance' as IABFilterType,
  pets: 'iab_pets' as IABFilterType,
  politics: 'iab_politics' as IABFilterType,
  pop_culture: 'iab_pop_culture' as IABFilterType,
  productivity: 'iab_productivity' as IABFilterType,
  real_estate: 'iab_real_estate' as IABFilterType,
  religion_and_spirituality: 'iab_religion_and_spirituality' as IABFilterType,
  science: 'iab_science' as IABFilterType,
  shopping: 'iab_shopping' as IABFilterType,
  sports: 'iab_sports' as IABFilterType,
  style_and_fashion: 'iab_style_and_fashion' as IABFilterType,
  technology_and_computing: 'iab_technology_and_computing' as IABFilterType,
  travel: 'iab_travel' as IABFilterType,
  video_gaming: 'iab_video_gaming' as IABFilterType,
  war_and_conflicts: 'iab_war_and_conflicts' as IABFilterType,
};

export const IAB_FILTERS_NAMES = {
  [IAB_FILTER_KEY.attractions]: 'Attractions' as IABFilterType,
  [IAB_FILTER_KEY.automotive]: 'Automotive' as IABFilterType,
  [IAB_FILTER_KEY.books_and_literature]: 'Books and Literature' as IABFilterType,
  [IAB_FILTER_KEY.business_and_finance]: 'Business and Finance' as IABFilterType,
  [IAB_FILTER_KEY.careers]: 'Careers' as IABFilterType,
  [IAB_FILTER_KEY.communication]: 'Communication' as IABFilterType,
  [IAB_FILTER_KEY.crime]: 'Crime' as IABFilterType,
  [IAB_FILTER_KEY.disasters]: 'Disasters' as IABFilterType,
  [IAB_FILTER_KEY.education]: 'Education' as IABFilterType,
  [IAB_FILTER_KEY.entertainment]: 'Entertainment' as IABFilterType,
  [IAB_FILTER_KEY.events]: 'Events' as IABFilterType,
  [IAB_FILTER_KEY.family_and_relationships]: 'Family and Relationships' as IABFilterType,
  [IAB_FILTER_KEY.fine_art]: 'Fine Art' as IABFilterType,
  [IAB_FILTER_KEY.food_and_drink]: 'Food & Drink' as IABFilterType,
  [IAB_FILTER_KEY.genres]: 'Genres' as IABFilterType,
  [IAB_FILTER_KEY.healthy_living]: 'Healthy Living' as IABFilterType,
  [IAB_FILTER_KEY.hobbies_and_interests]: 'Hobbies & Interests' as IABFilterType,
  [IAB_FILTER_KEY.holidays]: 'Holidays' as IABFilterType,
  [IAB_FILTER_KEY.home_and_garden]: 'Home & Garden' as IABFilterType,
  [IAB_FILTER_KEY.law]: 'Law' as IABFilterType,
  [IAB_FILTER_KEY.maps_and_navigation]: 'Maps & Navigation' as IABFilterType,
  [IAB_FILTER_KEY.medical_health]: 'Medical Health' as IABFilterType,
  [IAB_FILTER_KEY.music]: 'Music' as IABFilterType,
  [IAB_FILTER_KEY.personal_celebrations_and_life_events]:
    'Personal Celebrations & Life Events' as IABFilterType,
  [IAB_FILTER_KEY.personal_finance]: 'Personal Finance' as IABFilterType,
  [IAB_FILTER_KEY.pets]: 'Pets' as IABFilterType,
  [IAB_FILTER_KEY.politics]: 'Politics' as IABFilterType,
  [IAB_FILTER_KEY.pop_culture]: 'Pop Culture' as IABFilterType,
  [IAB_FILTER_KEY.productivity]: 'Productivity' as IABFilterType,
  [IAB_FILTER_KEY.real_estate]: 'Real Estate' as IABFilterType,
  [IAB_FILTER_KEY.religion_and_spirituality]: 'Religion & Spirituality' as IABFilterType,
  [IAB_FILTER_KEY.science]: 'Science' as IABFilterType,
  [IAB_FILTER_KEY.shopping]: 'Shopping' as IABFilterType,
  [IAB_FILTER_KEY.sports]: 'Sports' as IABFilterType,
  [IAB_FILTER_KEY.style_and_fashion]: 'Style & Fashion' as IABFilterType,
  [IAB_FILTER_KEY.technology_and_computing]: 'Technology & Computing' as IABFilterType,
  [IAB_FILTER_KEY.travel]: 'Travel' as IABFilterType,
  [IAB_FILTER_KEY.video_gaming]: 'Video Gaming' as IABFilterType,
  [IAB_FILTER_KEY.war_and_conflicts]: 'War & Conflicts' as IABFilterType,
};

export const APPLE_FILTER_KEY = {
  arts: 'apple_arts' as AppleFilterType,
  business: 'apple_business' as AppleFilterType,
  comedy: 'apple_comedy' as AppleFilterType,
  education: 'apple_education' as AppleFilterType,
  fiction: 'apple_fiction' as AppleFilterType,
  government: 'apple_government' as AppleFilterType,
  history: 'apple_history' as AppleFilterType,
  health_and_fitness: 'apple_health_and_fitness' as AppleFilterType,
  kids_and_family: 'apple_kids_and_family' as AppleFilterType,
  leisure: 'apple_leisure' as AppleFilterType,
  music: 'apple_music' as AppleFilterType,
  news: 'apple_news' as AppleFilterType,
  religion_and_spirituality: 'apple_religion_and_spirituality' as AppleFilterType,
  science: 'apple_science' as AppleFilterType,
  society_and_culture: 'apple_society_and_culture' as AppleFilterType,
  sports: 'apple_sports' as AppleFilterType,
  technology: 'apple_technology' as AppleFilterType,
  true_crime: 'apple_true_crime' as AppleFilterType,
  tv_and_film: 'apple_tv_and_film' as AppleFilterType,
};

export const APPLE_FILTERS_NAMES = {
  [APPLE_FILTER_KEY.arts]: 'Arts' as AppleFilterType,
  [APPLE_FILTER_KEY.business]: 'Business' as AppleFilterType,
  [APPLE_FILTER_KEY.comedy]: 'Comedy' as AppleFilterType,
  [APPLE_FILTER_KEY.education]: 'Education' as AppleFilterType,
  [APPLE_FILTER_KEY.fiction]: 'Fiction' as AppleFilterType,
  [APPLE_FILTER_KEY.government]: 'Government' as AppleFilterType,
  [APPLE_FILTER_KEY.history]: 'History' as AppleFilterType,
  [APPLE_FILTER_KEY.health_and_fitness]: 'Health & Fitness' as AppleFilterType,
  [APPLE_FILTER_KEY.kids_and_family]: 'Kids & Family' as AppleFilterType,
  [APPLE_FILTER_KEY.leisure]: 'Leisure' as AppleFilterType,
  [APPLE_FILTER_KEY.music]: 'Music' as AppleFilterType,
  [APPLE_FILTER_KEY.news]: 'News' as AppleFilterType,
  [APPLE_FILTER_KEY.religion_and_spirituality]: 'Religion & Spirituality' as AppleFilterType,
  [APPLE_FILTER_KEY.science]: 'Science' as AppleFilterType,
  [APPLE_FILTER_KEY.society_and_culture]: 'Society & Culture' as AppleFilterType,
  [APPLE_FILTER_KEY.sports]: 'Sports' as AppleFilterType,
  [APPLE_FILTER_KEY.technology]: 'Technology' as AppleFilterType,
  [APPLE_FILTER_KEY.true_crime]: 'True Crime' as AppleFilterType,
  [APPLE_FILTER_KEY.tv_and_film]: 'TV & Film' as AppleFilterType,
};

export const CATEGORIES_NAME_MAPPER = {
  [CONTEXTUAL_FILTERS.IAB as string]: IAB_FILTERS_NAMES,
  [CONTEXTUAL_FILTERS.APPLE as string]: APPLE_FILTERS_NAMES,
};

export const NAMED_ENTITY_TYPE = {
  ORG: 'ORG' as NamedEntityType,
  PERSON: 'PERSON' as NamedEntityType,
  PRODUCT: 'PRODUCT' as NamedEntityType,
  WORK: 'WORK' as NamedEntityType,
  LOC: 'LOC' as NamedEntityType,
  LAW: 'LAW' as NamedEntityType,
  GPE: 'GPE' as NamedEntityType,
  NORP: 'NORP' as NamedEntityType,
};

export const IAB_CONTEXTUAL_CATEGORIES = {
  Attractions: {
    'Amusement and Theme Parks': {},
    'Bars & Restaurants': {},
    'Casinos & Gambling': {},
    'Historic Site and Landmark Tours': {},
    'Malls & Shopping Centers': {},
    'Museums & Galleries': {},
    Nightclubs: {},
    'Outdoor Attractions': {},
    Parks: {},
    'Theater Venues': {},
    'Zoos & Aquariums': {},
  },
  Automotive: {
    'Auto Body Styles': {
      'Commercial Trucks': {},
      Convertible: {},
      Coupe: {},
      Crossover: {},
      Hatchback: {},
      Microcar: {},
      Minivan: {},
      'Off-Road Vehicles': {},
      'Pickup Trucks': {},
      Sedan: {},
      'Station Wagon': {},
      SUV: {},
      Van: {},
    },
    'Auto Buying and Selling': {},
    'Auto Insurance': {},
    'Auto Parts': {},
    'Auto Recalls': {},
    'Auto Rentals': {},
    'Auto Repair': {},
    'Auto Safety': {},
    'Auto Shows': {},
    'Auto Technology': {
      'Auto Infotainment Technologies': {},
      'Auto Navigation Systems': {},
      'Auto Safety Technologies': {},
    },
    'Auto Type': {
      'Budget Cars': {},
      'Certified Pre-Owned Cars': {},
      'Classic Cars': {},
      'Concept Cars': {},
      'Driverless Cars': {},
      'Green Vehicles': {},
      'Luxury Cars': {},
      'Performance Cars': {},
    },
    'Car Culture': {},
    'Dash Cam Videos': {},
    Motorcycles: {},
    'Road-Side Assistance': {},
    Scooters: {},
  },
  'Books and Literature': {
    'Art and Photography': {},
    'Comics and Graphic Novels': {},
    Fiction: {},
    Poetry: {},
  },
  'Business and Finance': {
    Business: {
      'Business Accounting & Finance': {},
      'Business Administration': {},
      'Business Banking & Finance': {
        'Angel Investment': {},
        Bankruptcy: {},
        'Business Loans': {},
        'Debt Factoring & Invoice Discounting': {},
        'Mergers and Acquisitions': {},
        'Private Equity': {},
        'Sale & Lease Back': {},
        'Venture Capital': {},
      },
      'Business I.T.': {},
      'Business Operations': {},
      'Business Utilities': {},
      'Consumer Issues': {
        Recalls: {},
      },
      'Executive Leadership & Management': {},
      'Government Business': {},
      'Green Solutions': {},
      'Human Resources': {},
      'Large Business': {},
      Logistics: {},
      'Marketing and Advertising': {},
      Sales: {},
      'Small and Medium-sized Business': {},
      Startups: {},
    },
    Economy: {
      Commodities: {},
      Currencies: {},
      'Financial Crisis': {},
      'Financial Reform': {},
      'Financial Regulation': {},
      'Gasoline Prices': {},
      'Housing Market': {},
      'Interest Rates': {},
      'Job Market': {},
    },
    Industries: {
      'Advertising Industry': {},
      Agriculture: {},
      'Apparel Industry': {},
      'Automotive Industry': {},
      'Aviation Industry': {},
      'Biotech and Biomedical Industry': {},
      'Civil Engineering Industry': {},
      'Construction Industry': {},
      'Defense Industry': {},
      'Education industry': {},
      'Entertainment Industry': {},
      'Environmental Services Industry': {},
      'Financial Industry': {},
      'Food Industry': {},
      'Healthcare Industry': {},
      'Hospitality Industry': {},
      'Information Services Industry': {},
      'Legal Services Industry': {},
      'Logistics and Transportation Industry': {},
      'Management Consulting Industry': {},
      'Manufacturing Industry': {},
      'Mechanical and Industrial Engineering Industry': {},
      'Media Industry': {},
      'Metals Industry': {},
      'Non-Profit Organizations': {},
      'Pharmaceutical Industry': {},
      'Power and Energy Industry': {},
      'Publishing Industry': {},
      'Real Estate Industry': {},
      'Retail Industry': {},
      'Technology Industry': {},
      'Telecommunications Industry': {},
    },
  },
  Careers: {
    Apprenticeships: {},
    'Career Advice': {},
    'Career Planning': {},
    'Job Search': {
      'Job Fairs': {},
      'Resume Writing and Advice': {},
    },
    'Remote Working': {},
    'Vocational Training': {},
  },
  Communication: {},
  Crime: {},
  Disasters: {},
  Education: {
    'Adult Education': {},
    'College Education': {
      'College Planning': {},
      'Postgraduate Education': {
        'Professional School': {},
      },
      'Undergraduate Education': {},
    },
    'Early Childhood Education': {},
    'Educational Assessment': {
      'Standardized Testing': {},
    },
    Homeschooling: {},
    'Homework and Study': {},
    'Language Learning': {},
    'Online Education': {},
    'Primary Education': {},
    'Private School': {},
    'Secondary Education': {},
    'Special Education': {},
  },
  Entertainment: {
    Movies: {},
    Music: {
      'Adult Album Alternative': {},
      'Adult Contemporary Music': {
        'Soft AC Music': {},
        'Urban AC Music': {},
      },
      'Alternative Music': {},
      Blues: {},
      "Children's Music": {},
      'Classic Hits': {},
      'Classical Music': {},
      'College Radio': {},
      'Comedy (Music and Audio)': {},
      'Contemporary Hits/Pop/Top 40': {},
      'Country Music': {},
      'Dance and Electronic Music': {},
      'Gospel Music': {},
      'Hip Hop Music': {},
      'Inspirational/New Age Music': {},
      Jazz: {},
      'Oldies/Adult Standards': {},
      'R&B/Soul/Funk': {},
      Reggae: {},
      'Religious (Music and Audio)': {},
      'Rock Music': {
        'Album-oriented Rock': {},
        'Alternative Rock': {},
        'Classic Rock': {},
        'Hard Rock': {},
        'Soft Rock': {},
      },
      'Songwriters/Folk': {},
      'Soundtracks, TV and Showtunes': {},
      'World/International Music': {},
      'Urban Contemporary Music': {},
      'Variety (Music and Audio)': {},
    },
    Television: {},
  },
  Events: {
    'Awards Shows': {},
    'Business Expos & Conferences': {},
    'Fan Conventions': {},
  },
  'Family and Relationships': {
    Bereavement: {},
    Dating: {},
    Divorce: {},
    Eldercare: {},
    'Marriage and Civil Unions': {},
    Parenting: {
      'Adoption and Fostering': {},
      'Daycare and Pre-School': {},
      'Internet Safety': {},
      'Parenting Babies and Toddlers': {},
      'Parenting Children Aged 4-11': {},
      'Parenting Teens': {},
      'Special Needs Kids': {},
    },
    'Single Life': {},
  },
  'Fine Art': {
    Costume: {},
    Dance: {},
    Design: {},
    'Digital Arts': {},
    'Fine Art Photography': {},
    'Modern Art': {},
    Opera: {},
    Theater: {},
  },
  'Food & Drink': {
    'Alcoholic Beverages': {},
    'Barbecues and Grilling': {},
    Cooking: {},
    'Desserts and Baking': {},
    'Dining Out': {},
    'Food Allergies': {},
    'Food Movements': {},
    'Healthy Cooking and Eating': {},
    'Non-Alcoholic Beverages': {},
    'Vegan Diets': {},
    'Vegetarian Diets': {},
    'World Cuisines': {},
  },
  Genres: {
    'Action/Adventure': {},
    'Animation & Anime': {},
    Biographies: {},
    Comedy: {},
    Documentary: {},
    Drama: {},
    Factual: {},
    'Family/Children': {},
    Fantasy: {},
    History: {},
    Holiday: {},
    Horror: {},
    Lifestyle: {},
    'Music Video': {},
    Musicals: {},
    Mystery: {},
    Nature: {},
    'Reality TV': {},
    Romance: {},
    'Science Fiction': {},
    'Soap Opera': {},
    'Special Interest (Indie/Art House)': {},
    'Sports Radio': {},
    'Talk Radio': {
      'Public Radio': {},
    },
    'Talk Show': {},
    'True Crime': {},
    Western: {},
    'Young Adult': {},
  },
  'Healthy Living': {
    "Children's Health": {},
    'Fitness and Exercise': {
      'Participant Sports': {},
      'Running and Jogging': {},
    },
    "Men's Health": {},
    Nutrition: {},
    'Senior Health': {},
    'Weight Loss': {},
    Wellness: {
      'Alternative Medicine': {
        'Herbs and Supplements': {},
        'Holistic Health': {},
      },
      'Physical Therapy': {},
      'Smoking Cessation': {},
    },
    "Women's Health": {},
  },
  'Hobbies & Interests': {
    'Antiquing and Antiques': {},
    'Arts and Crafts': {
      Beadwork: {},
      'Candle and Soap Making': {},
      'Drawing and Sketching': {},
      'Jewelry Making': {},
      Needlework: {},
      Painting: {},
      Photography: {},
      Scrapbooking: {},
      Woodworking: {},
    },
    Beekeeping: {},
    Birdwatching: {},
    Cigars: {},
    Collecting: {
      'Comic Books': {},
      'Stamps and Coins': {},
    },
    'Content Production': {
      'Audio Production': {},
      'Freelance Writing': {},
      Screenwriting: {},
      'Video Production': {},
    },
    'Games and Puzzles': {
      'Board Games and Puzzles': {},
      'Card Games': {},
      'Roleplaying Games': {},
    },
    'Genealogy and Ancestry': {},
    'Magic and Illusion': {},
    'Model Toys': {},
    'Musical Instruments': {},
    'Paranormal Phenomena': {},
    'Radio Control': {},
    'Sci-fi and Fantasy': {},
    'Workshops and Classes': {},
  },
  Holidays: {
    'National & Civic Holidays': {},
  },
  'Home & Garden': {
    Gardening: {},
    'Home Appliances': {},
    'Home Entertaining': {},
    'Home Improvement': {},
    'Home Security': {},
    'Indoor Environmental Quality': {},
    'Interior Decorating': {},
    Landscaping: {},
    'Outdoor Decorating': {},
    'Remodeling & Construction': {},
    'Smart Home': {},
  },
  Law: {},
  'Maps & Navigation': {},
  'Medical Health': {
    'Cosmetic Medical Services': {},
    'Diseases and Conditions': {
      Allergies: {},
      'Blood Disorders': {},
      'Bone and Joint Conditions': {},
      'Brain and Nervous System Disorders': {},
      Cancer: {},
      'Cold and Flu': {},
      'Dental Health': {},
      Diabetes: {},
      'Digestive Disorders': {},
      'Ear, Nose and Throat Conditions': {},
      'Endocrine and Metabolic Diseases': {
        'Hormonal Disorders': {},
        Menopause: {},
        'Thyroid Disorders': {},
      },
      'Eye and Vision Conditions': {},
      'Foot Health': {},
      'Heart and Cardiovascular Diseases': {},
      'Infectious Diseases': {},
      Injuries: {
        'First Aid': {},
      },
      'Lung and Respiratory Health': {},
      'Mental Health': {},
      'Reproductive Health': {
        'Birth Control': {},
        Infertility: {},
        Pregnancy: {},
      },
      'Sexual Health': {
        'Sexual Conditions': {},
      },
      'Skin and Dermatology': {},
      'Sleep Disorders': {},
      'Substance Abuse': {},
    },
    'Medical Tests': {},
    'Pharmaceutical Drugs': {},
    Surgery: {},
    Vaccines: {},
  },
  'Personal Celebrations & Life Events': {
    Anniversary: {},
    'Baby Shower': {},
    'Bachelor Party': {},
    'Bachelorette Party': {},
    Birth: {},
    Birthday: {},
    Funeral: {},
    Graduation: {},
    Prom: {},
    Wedding: {},
  },
  'Personal Finance': {
    'Consumer Banking': {},
    'Financial Assistance': {
      'Government Support and Welfare': {},
      'Student Financial Aid': {},
    },
    'Financial Planning': {},
    'Frugal Living': {},
    'Home Utilities': {
      'Gas and Electric': {},
      'Internet Service Providers': {},
      'Phone Services': {},
      'Water Services': {},
    },
    Insurance: {
      'Health Insurance': {},
      'Home Insurance': {},
      'Life Insurance': {},
      'Motor Insurance': {},
      'Pet Insurance': {},
      'Travel Insurance': {},
    },
    'Personal Debt': {
      'Credit Cards': {},
      'Home Financing': {},
      'Personal Loans': {},
      'Student Loans': {},
    },
    'Personal Investing': {
      'Hedge Funds': {},
      'Mutual Funds': {},
      Options: {},
      'Stocks and Bonds': {},
    },
    'Personal Taxes': {},
    'Retirement Planning': {},
  },
  Pets: {
    Birds: {},
    Cats: {},
    Dogs: {},
    'Fish and Aquariums': {},
    'Large Animals': {},
    'Pet Adoptions': {},
    'Pet Supplies': {},
    Reptiles: {},
    'Veterinary Medicine': {},
  },
  Politics: {
    'Civic affairs': {},
    Elections: {},
    'Political Issues & Policy': {},
  },
  'Pop Culture': {
    'Celebrity Deaths': {},
    'Celebrity Families': {},
    'Celebrity Homes': {},
    'Celebrity Pregnancy': {},
    'Celebrity Relationships': {},
    'Celebrity Scandal': {},
    'Celebrity Style': {},
    'Humor and Satire': {},
  },
  Productivity: {},
  'Real Estate': {
    Apartments: {},
    'Developmental Sites': {},
    'Hotel Properties': {},
    Houses: {},
    'Industrial Property': {},
    'Land and Farms': {},
    'Office Property': {},
    'Real Estate Buying and Selling': {},
    'Real Estate Renting and Leasing': {},
    'Retail Property': {},
    'Vacation Properties': {},
  },
  'Religion & Spirituality': {
    Agnosticism: {},
    Astrology: {},
    Atheism: {},
    Buddhism: {},
    Christianity: {},
    Hinduism: {},
    Islam: {},
    Judaism: {},
    Sikhism: {},
    Spirituality: {},
  },
  Science: {
    'Biological Sciences': {},
    Chemistry: {},
    Environment: {},
    Genetics: {},
    Geography: {},
    Geology: {},
    Physics: {},
    'Space and Astronomy': {},
    Weather: {},
  },
  'Sensitive Topics': {
    'Adult & Explicit Sexual Content': {},
    'Arms & Ammunition': {},
    'Crime & Harmful Acts to Individuals, Society & Human Right Violations': {},
    'Death, Injury, or Military Conflict': {},
    'Debated Sensitive Social Issues': {},
    'Hate Speech and Acts of Aggression': {},
    'Illegal Drugs, Tobacco, eCigarettes, Vaping, Alcohol': {},
    'Obscenity and Profanity': {},
    'Online Piracy': {},
    'Spam or Harmful Content': {},
    Terrorism: {},
  },
  Shopping: {
    "Children's Games and Toys": {},
    'Coupons and Discounts': {},
    'Flower Shopping': {},
    'Gifts and Greetings Cards': {},
    'Grocery Shopping': {},
    'Holiday Shopping': {},
    'Household Supplies': {},
    'Lotteries and Scratchcards': {},
    'Party Supplies and Decorations': {},
    'Sales and Promotions': {},
  },
  Sports: {
    'American Football': {},
    'Australian Rules Football': {},
    'Auto Racing': {
      'Motorcycle Sports': {},
    },
    Badminton: {},
    Baseball: {},
    Basketball: {},
    'Beach Volleyball': {},
    Bodybuilding: {},
    Bowling: {},
    Boxing: {},
    Cheerleading: {},
    'College Sports': {
      'College Baseball': {},
      'College Basketball': {},
      'College Football': {},
    },
    Cricket: {},
    Cycling: {},
    Darts: {},
    'Disabled Sports': {},
    Diving: {},
    'Equine Sports': {
      'Horse Racing': {},
    },
    'Extreme Sports': {
      'Canoeing and Kayaking': {},
      Climbing: {},
      Paintball: {},
      'Scuba Diving': {},
      Skateboarding: {},
      Snowboarding: {},
      'Surfing and Bodyboarding': {},
      'Waterskiing and Wakeboarding': {},
    },
    'Fantasy Sports': {},
    'Field Hockey': {},
    'Figure Skating': {},
    'Fishing Sports': {},
    Golf: {},
    Gymnastics: {},
    'Hunting and Shooting': {},
    'Ice Hockey': {},
    'Inline Skating': {},
    Lacrosse: {},
    'Martial Arts': {},
    'Olympic Sports': {
      'Summer Olympic Sports': {},
      'Winter Olympic Sports': {},
    },
    'Poker and Professional Gambling': {},
    Rodeo: {},
    Rowing: {},
    Rugby: {
      'Rugby League': {},
      'Rugby Union': {},
    },
    Sailing: {},
    Skiing: {},
    'Snooker/Pool/Billiards': {},
    Soccer: {},
    Softball: {},
    'Sports Equipment': {},
    Squash: {},
    Swimming: {},
    'Table Tennis': {},
    Tennis: {},
    'Track and Field': {},
    Volleyball: {},
    Walking: {},
    'Water Polo': {},
    Weightlifting: {},
    Wrestling: {},
  },
  'Style & Fashion': {
    Beauty: {
      'Hair Care': {},
      'Makeup and Accessories': {},
      'Nail Care': {},
      'Natural and Organic Beauty': {},
      'Perfume and Fragrance': {},
      'Skin Care': {},
    },
    'Body Art': {},
    "Children's Clothing": {},
    'Designer Clothing': {},
    'Fashion Trends': {},
    'High Fashion': {},
    "Men's Fashion": {
      "Men's Accessories": {
        "Men's Jewelry and Watches": {},
      },
      "Men's Clothing": {
        "Men's Business Wear": {},
        "Men's Casual Wear": {},
        "Men's Formal Wear": {},
        "Men's Outerwear": {},
        "Men's Sportswear": {},
        "Men's Underwear and Sleepwear": {},
      },
      "Men's Shoes and Footwear": {},
    },
    'Personal Care': {
      'Bath and Shower': {},
      'Deodorant and Antiperspirant': {},
      'Oral care': {},
      Shaving: {},
    },
    'Street Style': {},
    "Women's Fashion": {
      "Women's Accessories": {
        "Women's Glasses": {},
        "Women's Handbags and Wallets": {},
        "Women's Hats and Scarves": {},
        "Women's Jewelry and Watches": {},
      },
      "Women's Clothing": {
        "Women's Business Wear": {},
        "Women's Casual Wear": {},
        "Women's Formal Wear": {},
        "Women's Intimates and Sleepwear": {},
        "Women's Outerwear": {},
        "Women's Sportswear": {},
      },
      "Women's Shoes and Footwear": {},
    },
  },
  'Technology & Computing': {
    'Artificial Intelligence': {},
    'Augmented Reality': {},
    Computing: {
      'Computer Networking': {},
      'Computer Peripherals': {},
      'Software and Applications': {
        '3-D Graphics': {},
        'Antivirus Software': {},
        Browsers: {},
        'Computer Animation': {},
        Databases: {},
        'Desktop Publishing': {},
        'Digital Audio': {},
        'Graphics Software': {},
        'Operating Systems': {},
        'Photo Editing Software': {},
        'Shareware and Freeware': {},
        'Video Software': {},
        'Web Conferencing': {},
      },
    },
    'Data Storage and Warehousing': {},
    Desktops: {},
    'Information and Network Security': {},
    Internet: {
      'Cloud Computing': {},
      Email: {},
      'Internet for Beginners': {},
      'Internet of Things': {},
      'IT and Internet Support': {},
      Search: {},
      'Social Networking': {},
      'Web Design and HTML': {},
      'Web Development': {},
      'Web Hosting': {},
    },
    Laptops: {},
    'Programming Languages': {},
    'Consumer Electronics': {
      'Cameras and Camcorders': {},
      'Home Entertainment Systems': {},
      Smartphones: {},
      'Tablets and E-readers': {},
      'Wearable Technology': {},
    },
    Robotics: {},
    'Virtual Reality': {},
  },
  Travel: {
    'Travel Accessories': {},
    'Travel Locations': {
      'Africa Travel': {},
      'Asia Travel': {},
      'Australia and Oceania Travel': {},
      'Europe Travel': {},
      'North America Travel': {},
      'Polar Travel': {},
      'South America Travel': {},
    },
    'Travel Preparation and Advice': {},
    'Travel Type': {
      'Adventure Travel': {},
      'Air Travel': {},
      'Beach Travel': {},
      'Bed & Breakfasts': {},
      'Budget Travel': {},
      'Business Travel': {},
      Camping: {},
      Cruises: {},
      'Day Trips': {},
      'Family Travel': {},
      'Honeymoons and Getaways': {},
      'Hotels and Motels': {},
      'Rail Travel': {},
      'Road Trips': {},
      Spas: {},
    },
  },
  'Video Gaming': {
    'Console Games': {},
    eSports: {},
    'Mobile Games': {},
    'PC Games': {},
    'Video Game Genres': {
      'Action Video Games': {},
      'Action-Adventure Video Games': {},
      'Adult Video Games': {},
      'Adventure Video Games': {},
      'Casino and Gambling Video Games': {},
      'Casual Games': {},
      'Educational Video Games': {},
      'Exercise and Fitness Video Games': {},
      'Family Video Games': {},
      'Horror Video Games': {},
      MMOs: {},
      'Music and Party Video Games': {},
      'Puzzle Video Games': {},
      'Racing Video Games': {},
      'Role-Playing Video Games': {},
      'Simulation Video Games': {},
      'Sports Video Games': {},
      'Strategy Video Games': {},
    },
  },
  'War and Conflicts': {},
};

export const APPLE_PODCAST_CATEGORIES = {
  Arts: {
    Books: {},
    Design: {},
    'Fashion & Beauty': {},
    Food: {},
    'Performing Arts': {},
    'Visual Arts': {},
  },
  Business: {
    Careers: {},
    Entrepreneurship: {},
    Investing: {},
    Management: {},
    Marketing: {},
    'Non-Profit': {},
  },
  Comedy: {
    'Comedy Interviews': {},
    Improv: {},
    'Stand-Up': {},
  },
  Education: {
    Courses: {},
    'How To': {},
    'Language Learning': {},
    'Self-Improvement': {},
  },
  Fiction: {
    'Comedy Fiction': {},
    Drama: {},
    'Science Fiction': {},
  },
  Government: {},
  History: {},
  'Health & Fitness': {
    'Alternative Health': {},
    Fitness: {},
    Medicine: {},
    'Mental Health': {},
    Nutrition: {},
    Sexuality: {},
  },
  'Kids & Family': {
    'Education for Kids': {},
    Parenting: {},
    'Pets & Animals': {},
    'Stories for Kids': {},
  },
  Leisure: {
    'Animation & Manga': {},
    Automotive: {},
    Aviation: {},
    Crafts: {},
    Games: {},
    Hobbies: {},
    'Home & Garden': {},
    'Video Games': {},
  },
  Music: {
    'Music Commentary': {},
    'Music History': {},
    'Music Interviews': {},
  },
  News: {
    'Business News': {},
    'Daily News': {},
    'Entertainment News': {},
    'News Commentary': {},
    Politics: {},
    'Sports News': {},
    'Tech News': {},
  },
  'Religion & Spirituality': {
    Buddhism: {},
    Christianity: {},
    Hinduism: {},
    Islam: {},
    Judaism: {},
    Religion: {},
    Spirituality: {},
  },
  Science: {
    Astronomy: {},
    Chemistry: {},
    'Earth Sciences': {},
    'Life Sciences': {},
    Mathematics: {},
    'Natural Sciences': {},
    Nature: {},
    Physics: {},
    'Social Sciences': {},
  },
  'Society & Culture': {
    Documentary: {},
    'Personal Journals': {},
    Philosophy: {},
    'Places & Travel': {},
    Relationships: {},
  },
  Sports: {
    Baseball: {},
    Basketball: {},
    Cricket: {},
    'Fantasy Sports': {},
    Football: {},
    Golf: {},
    Hockey: {},
    Rugby: {},
    Running: {},
    Soccer: {},
    Swimming: {},
    Tennis: {},
    Volleyball: {},
    Wilderness: {},
    Wrestling: {},
  },
  Technology: {},
  'True Crime': {},
  'TV & Film': {
    'After Shows': {},
    'Film History': {},
    'Film Interviews': {},
    'Film Reviews': {},
    'TV Reviews': {},
  },
};
